export default {
  message: {
    category: 'Category',
    hello: 'hello world!',
    totWasted: 'Totally wasted',
    totWastedDescription: 'the drinking game to play with friends!',
    waitingHostCard: 'Waiting the first card from the game host'
  },
  page: {
    card: {
      drink: 'Drinking Card',
      rule: 'New Rule Card',
      pause: 'Pause moment'
    },
    clickToGoNext: 'Swipe right or left',
    home: {
      disclaimer: {
        title: 'Warning',
        description: `Please be aware that this game can be dangerous. 
        Do NOT play this game if:
        > You're underage 
        > You are not at a safe place 
        > You need to drive later`,
        accept: 'I\'m safe!',
        reject: 'Maybe next time'
      }
    },
    lang: {
      'en': 'English',
      'pt': 'Português',
      'fr': 'Français',
      quitSharedSession: 'Leave this game session.'
    },
    footer: {
      gameOptionsButton: 'Game options',
      aboutButton: 'About the game'
    }
  },
  game: {
    autoPlay: 'Auto play the cards:',
    autoPlaySpeed: 'Speed of auto play (seconds)',
    createSharedGame: 'Create Shared Game'
  },
  modal: {
    gameOptions: {
      title: 'Game Options'
    },
    sharedGame: {
      title: 'Play with Friends!',
      description: 'Do you want to play with your friends? It doesn\'t matter where they are! Just host a session.',
      createSessionButton: 'Create Session',
      shareWithFriendsLink: 'Share this link with your friends'
    }
  }
}
